export default "<title>\n    {{title}}\n</title>\n<mat-icon style=\"vertical-align: text-top;\" aria-label=\"delete\">{{icon}}</mat-icon> {{message}}"